import { lazy } from 'react';

export const LazyPaymentPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--payment-page" */ './payment-page'
    ),
);
